import {useContext} from 'react'
import { LanguageContext } from '../../context'
import { getItemVal,getValueMultiLookup,getItemHtmlVal } from '../../Data/GeneralFanction';
import './DataInfo.css'
import parse from 'html-react-parser';

const DataInfo = ({tab,dataSet,showTitle}) => {

    const {language}=useContext(LanguageContext);

    const FixedUrl=(url)=>{
    
      if(url==null)
        return "";
      if(url.indexOf('/')==0)
        url=window.srcSiteUrl+url//process.env.REACT_APP_APIURL+url;
      return url;
  
    }

  return (
    <div className='data-info-container'>
       {showTitle && <h2>{tab.label[language]}</h2>}
        <ul>
        {
          
            tab.field.showFielsd.map((item,index)=>{
                return <>
                 <li key={index}>
                   { 
                   getItemVal(item.name[language],dataSet)!=null && getItemVal(item.name[language],dataSet)!='' &&
                     <>{item.title[language]!='' && <div className="title">{item.title[language]}:</div>}
                     <div className="desc">
                        {item.type == "text" && getItemVal(item.name[language], dataSet)}
                        {/* {item.type == "html" && converStringTotHtml(item.name[language], dataSet)}                                                                  */}
                        {item.type == "html" && <div dangerouslySetInnerHTML={{__html: getItemHtmlVal(item.name[language], dataSet)}} />}                                                                 
                        {item.type == "date" &&  getItemVal(item.name[language], dataSet)!=null && getItemVal(item.name[language], dataSet).split(" ")[0]}
                        {item.type == "lookup" && getValueMultiLookup(getItemVal(item.name[language], dataSet))}
                        {item.type == "link" && <a href={FixedUrl(getItemVal(item.name[language], dataSet))} target="_blank">
                          {item.linkTitle.isConst == true ? item.linkTitle[language] : getItemVal(item.linkTitle[language], dataSet)}</a>}
                      </div></>
                }
                </li>
</>
            })
          
        }
        </ul>

    </div>
  )
}

export default DataInfo